// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2NzCT","inner":"Form_inner__2SZts","range":"Form_range__2zxbw","name":"Form_name__2Kff7","actions":"Form_actions__2xlRF"};